module.exports = __webpack_public_path__ + "static/media/logo-obersound.aacb73b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo-obersound.svg
// module id = 942
// module chunks = 37